/**
 * 登录/注册页面
 */

import React, { useState } from "react";
import { useStore } from "../store";
import { login as apiLogin, register as apiRegister } from "../api";

interface Props {
  showToast: (msg: string, type: "success" | "error" | "info") => void;
}

export default function Login({ showToast }: Props) {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const login = useStore((s) => s.login);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
      showToast("请填写邮箱和主密码", "error");
      return;
    }
    if (isRegister && password.length < 6) {
      showToast("主密码至少 6 位", "error");
      return;
    }

    setLoading(true);
    const fn = isRegister ? apiRegister : apiLogin;
    const result = await fn(email, password);
    setLoading(false);

    if (result.ok && result.data) {
      login(result.data.userId, result.data.email, result.data.token, password);
      showToast(isRegister ? "注册成功！" : "登录成功！", "success");
    } else {
      showToast(result.error || "操作失败", "error");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card card">
        <h1>PassKeeper</h1>
        <p className="subtitle">安全跨平台密码管理器</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">邮箱</label>
            <input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">主密码</label>
            <input
              id="password"
              type="password"
              placeholder={isRegister ? "设置你的主密码（至少6位）" : "输入主密码"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="form-actions">
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? "处理中..." : isRegister ? "注册" : "登录"}
            </button>
          </div>
        </form>

        <div className="form-footer">
          {isRegister ? (
            <>
              已有账号？{" "}
              <a onClick={() => setIsRegister(false)}>登录</a>
            </>
          ) : (
            <>
              没有账号？{" "}
              <a onClick={() => setIsRegister(true)}>注册</a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}